<template>
    <div :class="(!opciones.conFondo) ? 'container-fluid p-0' : 'container-fluid p-0 fondo-gris'">
        <div v-if="opciones.conTituloCarrusel.mostrar">
            <h2 :style="opciones.conTituloCarrusel.estilosCss">{{ opciones.conTituloCarrusel.texto }}</h2>
            <!-- <hr style="height: 1.7px; background: #ccbaba; margin-top: 0;"> -->
        </div>
        <CNoSeEncontraronResultados class="mt-4" v-if="!this.campoRequeridoEsValido(imagenes)" :opciones="{ tituloBusqueda: 'Búsqueda en avisos', NombreSeccion: 'Avisos' }"></CNoSeEncontraronResultados>
        <div v-show="this.campoRequeridoEsValido(imagenes)" class="row d-flex justify-content-center">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pl-0 pr-0 pt-1" v-if="mostrarCarrusel">
                <div id="carrusel">
                    <carousel 
                        :autoplay="opciones.configuraciones.autoPlay" 
                        :responsive="opciones.configuraciones.dimensiones">
                        <div v-for="(imagen,index) in imagenes" :key="'img' + index">
                            <!-- TITULO -->
                            <h3 v-if="opciones.conTitulo.mostrar" class="titulo-imagen">{{ imagen[opciones.conTitulo.identificador] }}</h3>
                            <!-- IMAGEN -->
                            <div v-if="opciones.conImagen.mostrar" class="contenedor-imagenes">
                                <img :style="opciones.configuraciones.estilosCss" :src="imagen[opciones.conImagen.identificador]" alt="img1" >
                            </div>
                            <!-- DESCRIPCION -->
                            <p v-if="opciones.conDescripcion.mostrar" class="text-center titulo">{{ imagen[opciones.conDescripcion.identificador] }}</p>
                            <!-- EN CASO DE REQUERIRLO, AGREGAR MAS ELEMENTOS A PARTIR DE ESTA LINEA -->
                        </div>
                    </carousel>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import carousel from 'vue-owl-carousel'
import CNoSeEncontraronResultados from '../Comun/CNoSeEncontraronResultados.vue'

export default {
    components: {
        carousel: carousel,
        CNoSeEncontraronResultados: CNoSeEncontraronResultados
    },
    props: {
        imagenes: {
            type: Array,
            default: () => []
        },
        opciones: {
            type: Object,
            default: () => ({ 
                conFondo: false,
                conTituloCarrusel: { mostrar: false, texto: 'Titulo', estilosCss: '' },
                conTitulo: { mostrar: false, identificador: 'Titulo' }, 
                conImagen: { mostrar: false, identificador: 'Ruta' }, 
                conDescripcion: { mostrar: false, identificador: 'Descripcion' }, 
                configuraciones: { 
                    autoPlay: false,
                    dimensiones: { 
                        0: { items: true, nav: false }, 
                        600:{ items: true, nav: false },
                        800: { items: true, nav: false },
                        1200: { items: true, nav: false }
                    },
                    estilosCss: 'height: 30em; border-radius: 10px 10px 10px 10px;'
                 } 
            })
        },
    },
    data() {
        return {
            
        }
    },
    methods: {
        campoRequeridoEsValido: function(campo) { 
            let esValido = false
            if(typeof campo === 'string' || campo instanceof String) {
                // valida que filtro tipo cadena no sea nula, indefinida y compuestas solo de espacios en blanco o saltos de linea
                if (campo != null && campo != undefined && campo != '' && campo.replace(/\s/g, '').length) {
                    esValido = true;
                }
            }
            else if (typeof campo === 'number' || campo instanceof Number) {
                // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
                if (campo != null && campo != undefined && campo > 0) {
                    esValido = true;
                }
            }
            else if (typeof campo === 'array' || campo instanceof Array) {
                // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
                if (campo != null && campo != undefined && campo.length > 0) {
                    esValido = true;
                }
            }
            else {
                if (campo != null && campo != undefined) {
                    esValido = true;
                }
            }
            return esValido;
        }
    },
    computed: {
        mostrarCarrusel() {
            return (this.campoRequeridoEsValido(this.imagenes) && this.imagenes.length > 0);
        }
    }
}
</script>
<style scoped>
.fondo-gris {
    padding: 2vmin 15vmin 0 15vmin !important;
}

.titulo-imagen {
   margin-top: 1em;
   font-family: 'AntenaBeta';
   font-size: 2em;
   font-weight: bold;
}

.contenedor-imagenes{
  margin:10px;
}

.imagen-carrusel{
  height: 30em;
  border-radius: 10px 10px 10px 10px;
}

</style>


// WEBPACK FOOTER //
// src/components/Intranet/Formatos/CCarruselImagenes.vue